module.exports = __webpack_public_path__ + "static/media/logo.b2eda894.svg";